import Button from "@mui/material/Button";
import { ArrowRight, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { IconButton } from "src/components/Default/LekUI/Button";
import { htmlFormatter } from "src/formatters/htmlFormatter";
import {
	useCloseCooperations,
	useCooperations,
} from "src/hooks/useCooperations";

export function Cooperations() {
	const { t } = useTranslation();
	const { data, isLoading } = useCooperations();
	const { mutateAsync } = useCloseCooperations();

	if (isLoading || !data || data.length === 0) {
		return null;
	}

	const [cooperation] = data;

	return (
		<div className="cooperation-container">
			<div className="cooperation">
				{cooperation.image_url && (
					<span className="cooperation--icon">
						<img src={cooperation.image_url} alt={cooperation.name} />
					</span>
				)}
				<div className="cooperation--text">
					{htmlFormatter(cooperation.text)}
				</div>
				{cooperation.link && (
					<Button
						className="cooperation--button"
						href={cooperation.link}
						target="_blank"
						rel="noreferrer noopener"
						endIcon={<ArrowRight className="icon-super-small" />}
					>
						{cooperation.button_text}
					</Button>
				)}
				<IconButton
					className="cooperation--close"
					aria-label={t("commands.close", "Zamknij")}
					onClick={() => mutateAsync({ id: cooperation.id })}
				>
					<X className="icon-small" />
				</IconButton>
			</div>
		</div>
	);
}
